export default function Datenschutz() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24" data-testid="datenschutz-page">
      <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary">Rechtliches</span>
      <h1 className="mt-3 font-display text-4xl font-bold sm:text-5xl">Datenschutzerklärung</h1>

      <section className="mt-10 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">1. Verantwortlicher</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der
          Datenschutz-Grundverordnung (DSGVO) ist:
        </p>
        <p>
          Computer Hellen<br />
          Dipl.-Ing. Alexander Hellen<br />
          Dinkelweg 21, 47638 Straelen<br />
          Telefon: 02834 9448700<br />
          E-Mail: info@computerhellen.de
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">2. Erhebung allgemeiner Daten (Server-Log-Dateien)</h2>
        <p>
          Beim Besuch dieser Website erhebt unser Hosting-Anbieter automatisch Informationen, die
          Ihr Browser übermittelt. Dazu gehören insbesondere: Browsertyp und -version, verwendetes
          Betriebssystem, Referrer-URL, Hostname des zugreifenden Rechners, Uhrzeit der
          Serveranfrage sowie die IP-Adresse.
        </p>
        <p>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
          fehlerfreien Betrieb und der Sicherheit der Website). Diese Daten werden nicht mit
          anderen Datenquellen zusammengeführt und nach kurzer Zeit gelöscht.
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">3. Kontaktaufnahme</h2>
        <p>
          Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre Angaben zur
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Rechtsgrundlage ist
          Art. 6 Abs. 1 lit. b DSGVO (Anbahnung/Erfüllung eines Vertrags) bzw. lit. f
          (berechtigtes Interesse an der Beantwortung Ihrer Anfrage).
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">4. Cookies</h2>
        <p>
          Diese Website verwendet keine Cookies zu Tracking- oder Marketingzwecken. Es kommen
          ausschließlich technisch notwendige Mechanismen zum Einsatz, soweit erforderlich.
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">5. Webfonts</h2>
        <p>
          Zur einheitlichen Darstellung von Schriftarten werden auf dieser Website Web-Schriften
          eingesetzt. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Schriften in
          Ihren Browser-Cache. Dabei kann eine Verbindung zum jeweiligen Anbieter aufgebaut
          werden, wodurch dieser Kenntnis darüber erlangt, dass über Ihre IP-Adresse unsere
          Website aufgerufen wurde. Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
          DSGVO im Interesse einer ansprechenden Darstellung unseres Online-Angebots.
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">6. Ihre Rechte</h2>
        <p>Sie haben gegenüber dem Verantwortlichen folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Recht auf Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p>
          Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die
          Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">7. SSL-/TLS-Verschlüsselung</h2>
        <p>
          Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung
          vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung
          erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
          wechselt.
        </p>
      </section>

      <section className="mt-8 space-y-3 text-base">
        <h2 className="font-display text-xl font-semibold">8. Aktualität</h2>
        <p>
          Stand dieser Datenschutzerklärung: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}.
          Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher
          Vorgaben kann es notwendig werden, diese Datenschutzerklärung anzupassen.
        </p>
      </section>
    </div>
  );
}
